import { memo, useState } from 'react';
import { useHistory } from 'react-router';
import { Box } from '@mui/material';

import CountDown from './CountDown';

import { InfoDialogModal } from '../Dialogs';

const Clock = ({
  expireTime = 900000,
  pago = false,
  searchPath,
  storageKey,
}) => {
  const [showModal, setShowModal] = useState(false);
  const history = useHistory();

  const startTime = Number(localStorage.getItem(storageKey));

  const expirationDate = startTime + expireTime;

  const handleExpiration = () => setShowModal(true);

  const handleCloseModal = () => {
    setShowModal(false);

    if (storageKey) {
      localStorage.removeItem(storageKey);
    }

    if (pago && searchPath) {
      history.push({
        pathname: searchPath,
        state: { goBack: true, refetch: true },
      });
    } else {
      history.goBack();
    }
  };

  return (
    <Box>
      <CountDown expirationDate={expirationDate} onFinish={handleExpiration} />

      <InfoDialogModal
        sx={{
          textAlign: 'center !important',
        }}
        isOpen={showModal}
        onClose={handleCloseModal}
        title="Tiempo expirado"
        text="Tu búsqueda ha superado el tiempo de espera. Para continuar, deberás volver a verificar la disponibilidad "
      />
    </Box>
  );
};

export default memo(Clock);
